import { capitalize } from 'affiny-core/helpers/string/capitalize';
import { IAnswer } from 'affiny-core/modules/api/models/reflist';
import React from 'react';
import { Flex, ChipsList } from 'affiny-ui/src';
import { ImportanceLevel } from '../importance-level';
import { Box } from '../primitives';
import styled from 'styled-components';

const MAX_SELECTION = 3;

interface IProps {
  title: string;
  label: string;
  answers: IAnswer[];
  selectedAnswers: number[];
  onChangeAnswer: (label: string, answer: number[]) => void;
  isMultiChoice: boolean;
  importanceValue?: number;
  importanceLabel?: string;
  isMobile?: boolean;
}

function QuestionCriterion({
  title,
  label,
  answers,
  selectedAnswers,
  onChangeAnswer,
  importanceValue,
  importanceLabel,
  isMultiChoice,
  isMobile,
}: IProps) {
  const handleImportanceLevelClick = (importanceId: number) =>
    onChangeAnswer(importanceLabel as string, [importanceId]);

  const handleAnswerClick = (newAnswers: number | number[]) => {
    onChangeAnswer(
      label,
      Array.isArray(newAnswers) ? newAnswers : [newAnswers]
    );
  };

  const handleClickItem = (newSelection: number) => {
    const selectionCopy = [...selectedAnswers];
    const index = selectionCopy.findIndex(id => id === newSelection);

    if (index !== -1) {
      if (selectionCopy.length > 1) {
        selectionCopy.splice(index, 1);
      }
    } else if (selectedAnswers.length < MAX_SELECTION)
      selectionCopy.push(newSelection);

    handleAnswerClick(selectionCopy);
  };

  const chips = answers?.map(({ id, label }) => {
    return {
      isSelected: selectedAnswers?.includes(id) ?? false,
      onClick: () =>
        isMultiChoice ? handleClickItem(id) : handleAnswerClick(id),
      label: capitalize(label) as string,
    };
  });

  return (
    <Box mb="xLarge">
      <Flex flexDirection="column">
        <ChipsList
          chips={chips}
          isMultiChoice={isMultiChoice}
          maxChoices={MAX_SELECTION}
          readOnly={false}
          title={title}
        />
      </Flex>

      {importanceLabel && importanceValue && (
        <SWrapper>
          <ImportanceLevel
            selectedValue={importanceValue}
            onClick={handleImportanceLevelClick}
            isMobile={isMobile}
          />
        </SWrapper>
      )}
    </Box>
  );
}

const SWrapper = styled.div`
  margin-top: ${({ theme }) => theme.space.medium};
`;

export default QuestionCriterion;
